import React, { Component } from "react";
import Logo from "../../assets/image/logo.svg";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { LangUpdateContext } from "./LangContext";
import { SIDE_NAV } from "../config/lang";

import { logout } from "../util/redux/actions";

const MENU = [
  { type: "section", label: { uk: "Основне", en: "Main", hy: "Հիմնական", ka: "მთავარი" }, role: ["all"] },
  { name: "photo_report", path: "/photo-review", icon: "photo_camera", role: ["all"] },
  { name: "visit", path: "/visit", icon: "location_on", role: ["all"] },
  { name: "all_reports", path: "/bi-report", icon: "bar_chart", role: ["all"] },
  { type: "section", label: { uk: "Управління", en: "Management", hy: "Կառավարում", ka: "მართვა" }, role: ["all"] },
  { name: "tasks", path: "/task", icon: "task", role: ["all"] },
  { name: "answers", path: "/task-review", icon: "quiz", role: ["all"] },
  { name: "my_uploads", path: "/tasks-import/3", icon: "upload", role: ["supervisor_manager"] },
  { name: "task_uploading", path: "/tasks-import", icon: "cloud_upload", role: ["supervisor_manager"] },
  { type: "section", label: { uk: "Управління персоналом", en: "Personnel management", hy: "Անձնակազմի կառավարում", ka: "პერსონალის მართვა" }, role: ["all"] },
  { name: "merchandiser", path: "/merchandiser", icon: "badge", role: ["all"] },
  { name: "supervisors", path: "/supervisors", icon: "supervisor_account", role: ["supervisor_manager"] },
  { type: "section", label: { uk: "Дані", en: "Data", hy: "Տվյալներ", ka: "მონაცემები" }, role: ["supervisor_manager", "supervisor"] },
  { name: "documents", path: "/document", icon: "description", role: ["all"] },
  { type: "section", label: { uk: "Точки", en: "Points", hy: "Կետեր", ka: "წერტილები" }, role: ["supervisor_manager", "supervisor"] },
  { name: "pt_points", path: "/points", icon: "pin_drop", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_networks", path: "/networks", icon: "hub", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_categories", path: "/categories", icon: "category", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_countries", path: "/countries", icon: "public", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_counties", path: "/counties", icon: "map", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_localities", path: "/localities", icon: "location_city", role: ["supervisor_manager", "supervisor"] },
  { name: "pt_point_groups", path: "/point_groups", icon: "workspaces", role: ["supervisor_manager", "supervisor"] },
];

const hasRole = (itemRole, userRole) => {
  if (Array.isArray(itemRole)) return itemRole.includes(userRole) || itemRole.includes("all");
  return itemRole === userRole || itemRole === "all";
};

class Aside extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: localStorage.getItem("hiddenAside") === "1" || false,
    };

    this.aside = null;
  }
  static contextType = LangUpdateContext;

  componentDidMount() {
    window.addEventListener("resize", this.findHeight);
    this.findHeight();

    if (this.props.location.pathname === "/k-form") {
      this.setState({ hide: true });
    }
    if (this.props.location.pathname === "/photo-review") {
      this.setState({ hide: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.findHeight);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sidebar !== this.props.sidebar) {
      this.setState({ hide: this.props.sidebar });
    }
    if (
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.location.pathname === "/photo-review"
    ) {
      this.setState({ hide: this.props.location.pathname });
    }
  }

  findHeight = () => {
    this.setState({ windowH: window.innerHeight });
  };

  hide = () => {
    const { hide } = this.state;
    this.setState({ hide: !hide }, () => {
      localStorage.setItem("hiddenAside", hide ? "0" : "1");
      this.aside.style.display = "none";
      let elem = document.getElementsByClassName("modal-backdrop show")[0];
      if (elem) {
        document.body.className = document.body.className.replace("modal-open", "");
        elem.parentNode.removeChild(elem);
      }
    });
  };

  logout = () => this.props.dispatch(logout());

  getLabel = name => {
    const { me } = this.props;
    if (!SIDE_NAV[name]) return name;
    return SIDE_NAV[name][me.language] || SIDE_NAV[name]["uk"] || name;
  };

  menuItem = item => {
    const { me } = this.props;
    const { hide } = this.state;

    if (item.type === "section") {
      if (!hasRole(item.role, me.role)) return null;
      const label = item.label[me.language] || item.label["en"] || item.label["uk"];
      // Rendered as a group splitter: a labelled header when expanded, a divider
      // line (label hidden via CSS) with a hover title when collapsed/folded.
      return (
        <div key={`section-${label}`} className="md-nav-section" title={label}>
          <span className="md-nav-section-label">{label}</span>
        </div>
      );
    }

    if (!hasRole(item.role, me.role)) return null;

    const { name, path, icon } = item;
    const label = this.getLabel(name);
    const isCurrent = this.props.location.pathname === path;

    const onClickFn = () => {
      if (window.innerWidth <= 922) {
        this.hide();
      } else if (hide) {
        this.setState({ hide: false });
      }
    };

    return (
      <Link
        key={`m-i-${name}`}
        to={path}
        onClick={onClickFn}
        title={label}
        className={`md-nav-item${isCurrent ? " md-nav-item-active" : ""}`}
      >
        <span className="md-nav-icon">{icon}</span>
        <span className="md-nav-item-text">{label}</span>
      </Link>
    );
  };

  render() {
    const { hide } = this.state;
    const { me } = this.props;

    if (!me) return null;

    const logoutLabel = SIDE_NAV["logout"][me.language] || SIDE_NAV["logout"]["uk"];

    return (
      <div
        id="aside"
        ref={el => (this.aside = el)}
        className={`app-aside modal nav-dropdown ${hide ? "folded" : ""}`}
        aria-hidden="true"
      >
        <div className="left md-nav-rail">
          <div className="md-nav-logo" onClick={this.hide}>
            <img src={Logo} alt="PicSell" className="md-nav-logo-img" />
          </div>

          <div className="md-nav-scroll">
            {MENU.map(this.menuItem)}
          </div>

          <div className="md-nav-bottom">
            <a className="md-nav-item" onClick={this.logout} title={logoutLabel} style={{ cursor: "pointer" }}>
              <span className="md-nav-icon">logout</span>
              <span className="md-nav-item-text">{logoutLabel}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

Aside = connect(state => ({
  me: state.me,
  sidebar: state.sidebar,
}))(Aside);

export default withRouter(Aside);
